<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="工单编号"
                prop="orderWorkNo"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.orderWorkNo"
                  placeholder="请输入工单编号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="工单状态" prop="status" style="width: 80%">
                <el-select clearable filterable v-model="searchForm.status" placeholder="请选择">
                  <el-option
                    v-for="item in statusTypeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px"></div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="orderWorkNo" label="订单编号" align="center">
        </el-table-column>
        <el-table-column
          prop="orderCategoryName"
          label="报修类型"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="userName" label="报修人" align="center">
        </el-table-column>
        <el-table-column prop="phone" label="报修人手机号码" align="center">
        </el-table-column>
        <el-table-column prop="houseNumber" label="房屋信息" align="center">
        </el-table-column>
        <el-table-column prop="handleUser" label="受理人" align="center">
        </el-table-column>
        <el-table-column prop="address" label="报修地址" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column
          prop="status"
          label="工单状态"
          align="center"
          :formatter="typeList"
        >
        </el-table-column>
        <el-table-column prop="evaluateTime" label="评价时间" align="center">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="updata(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <!-- 新增模态框 -->
        <el-dialog
          title="详情"
          :visible.sync="isAddModal"
          width="50%"
          :close-on-click-modal="false"
        >
        <orderInfo :addData="addData" :orderInfos="orderInfos"></orderInfo>
          <!-- <el-form
            ref="form"
            :model="addData"
            label-width="90px"
            id="printTest"
            :rules="addDataRules"
            label-position="center"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item label="订单编号" prop="orderWorkNo">
                  <el-input
                    v-model="addData.orderWorkNo"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="报修类型" prop="orderCategoryName">
                  <el-input
                    v-model="addData.orderCategoryName"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="报修人" prop="userName">
                  <el-input
                    v-model="addData.userName"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="房屋信息" prop="houseNumber">
                  <el-input
                    v-model="addData.houseNumber"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="报修内容" prop="des">
                  <el-input
                    type="textarea"
                    autosize
                    v-model="addData.des"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="报修图片" prop="createTime">
                  <div v-if="addData.img" style="cursor: pointer" v-viewer>
                    <img
                      :src="item"
                      v-for="(item, ind) in addData.img.split(',')"
                      :key="ind"
                      alt=""
                      style="width: 100px; height: 100px"
                    />
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="受理人" prop="handleUser">
                  <el-input
                    v-model="addData.handleUser"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="报修地址" prop="address">
                  <el-input
                    v-model="addData.address"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="分发时间" prop="distributeTime">
                  <el-input
                    v-model="addData.distributeTime"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="分发人员" prop="handleUser">
                  <el-input
                    v-model="addData.handleUser"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="接收时间" prop="receiveTime">
                  <el-input
                    v-model="addData.receiveTime"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="接收人员" prop="handleUser">
                  <el-input
                    v-model="addData.handleUser"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="报修时间" prop="createTime">
                  <el-input
                    v-model="addData.createTime"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="完成时间" prop="completeTime">
                  <el-input
                    v-model="addData.completeTime"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="完成图片" prop="createTime">
                  <div
                    v-if="addData.completeImg"
                    style="cursor: pointer"
                    v-viewer
                  >
                    <img
                      :src="item"
                      v-for="(item, ind) in addData.completeImg.split(',')"
                      :key="ind"
                      alt=""
                      style="width: 100px; height: 100px"
                    />
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="完成备注" prop="completeDesc">
                  <el-input
                    type="textarea"
                    autosize
                    v-model="addData.completeDesc"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="评价等级" prop="evaluateScore">
                  <el-select
                    clearable filterable
                    v-model="addData.evaluateScore"
                    disabled
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="评价时间" prop="evaluateTime">
                  <el-input
                    v-model="addData.evaluateTime"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="评价内容" prop="evaluateDesc">
                  <el-input
                    type="textarea"
                    autosize
                    v-model="addData.evaluateDesc"
                    placeholder="无"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form> -->
          <span slot="footer" class="dialog-footer">
            <el-button @click="isAddModal = false">确 定</el-button>
            <el-button type="primary" v-print="print"
            >打 印</el-button
          >
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import orderInfo from "@/components/orderInfo"
export default {
  components:{
    orderInfo
  },
  data() {
    return {
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      tableData: [],
      isShowloading: false,
      isAddModal: false,
      btnLoading: false,
      addData: {},
      addDataRules: {},
      searchForm: {
        orderWorkNo: "",
      },
      statusTypeList: [
        {
          id: "0",
          name: "待分发",
        },
        {
          id: 1,
          name: "待接收",
        },
        {
          id: 2,
          name: "已受理",
        },
        {
          id: 3,
          name: "已完成",
        },
        {
          id: 6,
          name: "已回复",
        },
        {
          id: 5,
          name: "已取消",
        },
        {
          id: 4,
          name: "已评价",
        },
      ],
      options: [
        {
          value: 1,
          label: "非常满意",
        },
        {
          value: 2,
          label: "满意",
        },
        {
          value: 3,
          label: "一般",
        },
        {
          value: 0,
          label: "暂无",
        },
      ],
      print: {
        id: 'printTest',
        popTitle: '', // 打印配置页上方的标题
        extraHead: '', // 最上方的头部文字，附加在head标签上的额外标签，使用逗号分割
        preview: false, // 是否启动预览模式，默认是false
        previewTitle: '预览的标题', // 打印预览的标题
        previewPrintBtnLabel: '预览结束，开始打印', // 打印预览的标题下方的按钮文本，点击可进入打印
        zIndex: 20002, // 预览窗口的z-index，默认是20002，最好比默认值更高
        previewBeforeOpenCallback () { console.log('正在加载预览窗口！'); console.log(that.msg, this) }, // 预览窗口打开之前的callback
        previewOpenCallback () { console.log('已经加载完预览窗口，预览打开了！') }, // 预览窗口打开时的callback
        beforeOpenCallback () { console.log('开始打印之前！') }, // 开始打印之前的callback
        openCallback () { console.log('执行打印了！') }, // 调用打印时的callback
        closeCallback () { console.log('关闭了打印工具！') }, // 关闭打印的callback(无法区分确认or取消)
        clickMounted () { console.log('点击v-print绑定的按钮了！') },
        // url: 'http://localhost:8080/', // 打印指定的URL，确保同源策略相同
        // asyncUrl (reslove) {
        //   setTimeout(() => {
        //     reslove('http://localhost:8080/')
        //   }, 2000)
        // },
        standard: '',
        extarCss: '',
        orderInfos:{}
      }
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    typeList(row) {
      if (row.status == 0) {
        return "待分发";
      } else if (row.status == 1) {
        return "待接收";
      } else if (row.status == 2) {
        return "已受理";
      } else if (row.status == 3) {
        return "已完成";
      } else if (row.status == 6) {
        return "已回复";
      } else if (row.status == 5) {
        return "已取消";
      } else if (row.status == 4) {
        return "已评价";
      }
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    updata(row) {
      this.modalTitle = "修改";
      this.$Apis.order_workmanageOrderDetail({orderWorkId:row.id}).then(res=>{
        if(res.code == 200){
          this.isAddModal = true;
           this.addData = JSON.parse(JSON.stringify(row));
           this.orderInfos = res.data;
        }else{
          this.$message.warning(res.msg)
        }
      })
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    submit() {},
    onLoad(ind) {
      this.isShowloading = true;
      if(ind == 1){
        this.currentPage = 1
      }
      let page = {
        current: this.currentPage,
        size: this.pageSize,
        type: 2,
        status: this.searchForm.status || "0,1,2,3,4,5,6",
        orderWorkNo: this.searchForm.orderWorkNo,
        orderWorkId:this.$route.query.id || ""
      };
      this.tableData = [];
      this.$Apis.orderWorkList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style  scoped>
/deep/.el-input.is-disabled .el-input__inner {
  color: #333;
  font-weight: bold;
  border: none;
  background: #fff;
}
/deep/ .el-textarea.is-disabled .el-textarea__inner{
  color: #333;
  font-weight: bold;
  border: none;
  background: #fff;
}
</style>